import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CheckoutNewPageRoutingModule } from './checkout-new-routing.module';



import { InputSelectModalComponent } from 'src/app/component/input-select-modal/input-select-modal.component';

import { CustomConfirmDialogComponent } from 'src/app/component/custom-confirm-dialog/custom-confirm-dialog.component';


import { CheckoutNewPage } from './checkout-new.page';

import { TranslateModule } from '@ngx-translate/core';
import { OTPVerificationPageModule } from '../modals/otp-verification/otp-verification.module';

import { PipeModule } from '../../core/pipe.module';
import { CalendarPageModule } from '../modals/calendar/calendar.module';
import { DeliveryTimesPageModule } from '../modals/delivery-times/delivery-times.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CheckoutNewPageRoutingModule,
    TranslateModule,
    OTPVerificationPageModule,
    PipeModule,
    CalendarPageModule,
    DeliveryTimesPageModule
  ],
  declarations: [CheckoutNewPage, InputSelectModalComponent, CustomConfirmDialogComponent],
  exports: [CheckoutNewPage]
})
export class CheckoutNewPageModule { }
